var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck3 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9367_33533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3453 3.604C10.5638 3.36727 10.5491 2.99822 10.3123 2.7797C10.0756 2.56118 9.70655 2.57594 9.48803 2.81267L2.89984 9.94988L0.995812 8.04586C0.768007 7.81805 0.39866 7.81805 0.170854 8.04586C-0.0569515 8.27366 -0.0569515 8.64301 0.170854 8.87082L2.50419 11.2041C2.61644 11.3164 2.7696 11.3781 2.92833 11.3749C3.08705 11.3717 3.23762 11.304 3.3453 11.1873L10.3453 3.604Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8453 3.604C14.0638 3.36727 14.0491 2.99822 13.8123 2.7797C13.5756 2.56118 13.2066 2.57594 12.988 2.81267L5.98803 10.396C5.76952 10.6327 5.78428 11.0018 6.02101 11.2203C6.25774 11.4388 6.62679 11.4241 6.8453 11.1873L13.8453 3.604Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9367_33533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Check3.31341c2219904569a8b96c1b44dd7f3b.svg";